
export const noPriceViewScreen = {
    eventCategory: "DIY_N_Price",
    eventAction: "No price screen view"
};
